module.exports = __webpack_public_path__ + "static/media/blog27.54ebf335.webp";